export default {
  background: '#2a4207',
};
